import { Layers } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface TabGroupIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const TabGroupIcon: React.FC<TabGroupIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Layers size={size} color={color} style={{ transform: 'rotate(-135deg)' }} />
        </IconWrapper>
    );
};
